// @flow
import { combineReducers } from "redux";
import { adminsReducer as admins } from "./admins-reducer";
import { celebrationsReducer as celebrations } from "./celebrations-reducer";
import { usersReducer as users } from "./users-reducer";
import { townsReducer as towns } from "./towns-reducer";
import { sessionReducer as session } from "./session-reducer";
import { modalsReducer as modals } from "./modals-reducer";
import { messagesReducer as messages } from "./messages-reducer";
import { settingsReducer as settings } from "./settings-reducer";
import { teamsReducer as teams } from "./teams-reducer";
import { teamMembersReducer as teamMembers } from "./team-members-reducer";
import { supplyDistributionSitesReducer as supplyDistributionSites } from "./supply-distribution-sites-reducer";
import { trashCollectionSitesReducer as trashCollectionSites } from "./trash-collection-sites-reducer";
import { trashDropsReducer as trashDrops } from "./trash-drops-reducer";
import { toolsReducer as tools } from "./tools-reducer";
import { eventInfoReducer as eventInfo } from "./event-info-reducer";
import { faqsReducer as faqs } from "./faqs-reducer";

const rootReducer = combineReducers<any, any>({
    admins,
    celebrations,
    eventInfo,
    faqs,
    messages,
    modals,
    session,
    settings,
    supplyDistributionSites,
    teams,
    teamMembers,
    tools,
    towns,
    trashCollectionSites,
    trashDrops,
    users
});

export default rootReducer;
